require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-185-import-a-project-from-primavera-p-6.json") })
        }
      }, "path---article-185-import-a-project-from-primavera-p-6");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-185-import-a-project-from-primavera-p-6!./.cache/json/article-185-import-a-project-from-primavera-p-6.json
// module id = 533
// module chunks = 231608221292675